import { Outlet, useLocation } from 'react-router-dom';
import EmployeeSidebar from './EmployeeSidebar';
import EmployeeNavbar from './EmployeeNavbar';
import { useAppSelector, useAppDispatch } from '../app/hooks';
import { setSidebarOpen } from '../features/ui/uiSlice';
import GlobalLoader from './GlobalLoader';
import { useOnlineStatus } from '../hooks/useOnlineStatus';
import { useGetTodayStatusQuery } from '../features/attendance/attendanceApi';
import { useEffect } from 'react';
import { setViewMode } from '../features/auth/authSlice';
import SupportCenterWidget from './SupportCenterWidget';

// Data-heavy pages that should use the full screen width instead of the narrow reading column.
const WIDE_PAGES = ['/ess/attendance'];

const EmployeeLayout = () => {
    const location = useLocation();
    const dispatch = useAppDispatch();
    const isSidebarOpen = useAppSelector((state) => state.ui.isSidebarOpen);
    const isAuthenticated = useAppSelector((state) => !!state.auth.accessToken);
    const isOnline = useOnlineStatus();

    // Smart Sync: Ensure mode is ESS when on Employee routes
    useEffect(() => {
        dispatch(setViewMode('ESS'));
    }, [dispatch]);

    // Task 4: Global Initialization (Sync-on-load for ESS)
    useGetTodayStatusQuery(undefined, { skip: !isAuthenticated });

    return (
        <div className="flex h-screen bg-gray-50 overflow-hidden">
            <GlobalLoader />

            {!isOnline && (
                <div className="fixed top-0 left-0 right-0 z-[60] bg-red-600 text-white text-center py-1 text-xs font-medium animate-pulse shadow-md">
                    No internet connection. Some features may be unavailable.
                </div>
            )}

            {/* Employee Sidebar */}
            <EmployeeSidebar />

            {/* Mobile Overlay */}
            {isSidebarOpen && (
                <div
                    className="fixed inset-0 z-20 bg-black bg-opacity-50 lg:hidden"
                    onClick={() => dispatch(setSidebarOpen(false))}
                ></div>
            )}

            {/* Main Content */}
            <div className="flex flex-col flex-1 w-full overflow-hidden">
                <EmployeeNavbar />

                <main className="flex-1 overflow-x-hidden overflow-y-auto bg-gray-50">
                    <div className={`mx-auto px-4 sm:px-6 lg:px-8 py-8 ${WIDE_PAGES.some((p) => location.pathname.startsWith(p)) ? 'max-w-none lg:px-10' : 'max-w-6xl'}`}>
                        <Outlet />
                    </div>
                </main>
            </div>

            {/* Global Support Widget */}
            <SupportCenterWidget />
        </div>
    );
};

export default EmployeeLayout;
